
import Vue from 'vue'
import NavigationTab from '@/components/shared/NavigationTab.vue'

export default Vue.extend({
  name: 'MesInformations',
  components: {
    NavigationTab,
  },
  data: () => ({
    items: [
      {
        path: 'lieux-de-visite',
        icon: 'mdi-map-marker-radius',
        title: 'title.places-to-visit',
      },
      {
        path: 'proprietaires',
        icon: 'mdi-account-tie',
        title: 'title.lot-sellers',
      },
      {
        path: 'entetes',
        icon: 'mdi-tag-text',
        title: 'title.headers',
      },
    ],
  }),
})
